import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL + "/api/users";

export const getUserService = async (email) => {
  // 201 → { …user } ó {} si no existe
  const response = await axios.get(`${BASE}/userByEmail/${email}`);
  return response.data || {};   // garantizo que siempre devuelva un objeto
};

export const addUserService = async (userObj) => {
  // 201 → { …newUser }
  const response = await axios.post(`${BASE}/newUser`, userObj);
  return response.data || {};
};

// import axios from "axios";

// export const getUserService = async (id) => {
//     const {data} = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/userByEmail/${id}`);
//     return data;
// }

// export const addUserService = async (obj) => {
//     const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/users/newUser`, obj);
//     return data;
// }